import React from 'react';
import './searchComponent.css';
import PropTypes from "prop-types";


export class SearchBar extends React.Component {
    constructor(props) {
        super(props);
        this.state = {value: this.props.value || ''}
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            this.setState({ value: this.props.value });
        }
    }


    render() {
        const {placeHolder, onSearchChange}=this.props;
        return (
            <div className="search__input search-bar">
                <input
                    type="text"
                    className='form-control'
                    placeholder={placeHolder || 'Search'}
                    onChange={(e)=> {
                        this.setState({value: e.target.value})
                        onSearchChange(e.target.value);
                    }}
                    value={this.state.value}
                />
                <button type=" submit"
                        className=" btn btn-default search-btn">
                    <span>Search</span></button>
                {this.state.value &&
                <button type="button"
                        className="btn btn-default clear-btn"
                        onClick={()=> {
                            this.setState({value: ''});
                            onSearchChange('');
                        }}><span>Clear</span></button>}
            </div>
        )
    }
}
SearchBar.propTypes = {
  placeHolder: PropTypes.string,
  onSearchChange: PropTypes.func,
  value: PropTypes.string,
};